import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

// Import your existing components
import CustomerApp from './App'; // Your original customer booking interface
import AdminApp from './AdminApp';       // Your admin interface

// Import the new debug component
import CustomerDebugPage from './components/CustomerDebugPage';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <Router>
        <Routes>
          {/* Customer booking interface - with wildcard for nested routes */}
          <Route path="/*" element={<CustomerApp />} />
          
          {/* Admin interface - with wildcard for nested routes */}
          <Route path="/admin/*" element={<AdminApp />} />
          
          {/* Debug page to diagnose customer 500 error */}
          <Route path="/debug" element={<CustomerDebugPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  </React.StrictMode>
);